export default {
  mounted() {
    this.stick = true
    this.pill = this.el.parentElement.querySelector('[data-room-new-messages]')
    this.signature = this.lastMessage()
    this.onScroll = () => { this.stick = this.el.scrollHeight - this.el.scrollTop - this.el.clientHeight < 120; if(this.stick) this.showPill(false) }
    this.onNew = () => { this.stick = true; this.showPill(false); this.el.scrollTo({top:this.el.scrollHeight, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}) }
    this.el.addEventListener('scroll',this.onScroll,{passive:true})
    this.pill?.addEventListener('click',this.onNew)
    this.frame = requestAnimationFrame(() => {this.el.scrollTop = this.el.scrollHeight})
  },
  beforeUpdate() { this.previous = {height:this.el.scrollHeight, top:this.el.scrollTop, hidden:Number(this.el.dataset.historyHidden)} },
  updated() {
    cancelAnimationFrame(this.frame)
    const signature = this.lastMessage()
    if(this.previous && Number(this.el.dataset.historyHidden) < this.previous.hidden) {
      this.stick = false
      this.el.scrollTop = this.previous.top + this.el.scrollHeight - this.previous.height
    } else if(this.stick) {
      this.frame = requestAnimationFrame(() => {this.el.scrollTop = this.el.scrollHeight})
    } else if(signature !== this.signature) this.showPill(true)
    this.signature = signature
    this.showPill(this.unread === true && !this.stick)
  },
  lastMessage() { const messages=this.el.querySelectorAll('[id^="room-message-"]'); const last=messages[messages.length-1]; return last ? `${last.id}:${last.textContent.length}` : '' },
  showPill(show) { this.unread = show; if(this.pill) {this.pill.hidden=!show;this.pill.dataset.show=String(show)} },
  destroyed() { cancelAnimationFrame(this.frame); this.el.removeEventListener('scroll',this.onScroll);this.pill?.removeEventListener('click',this.onNew) }
}
